import { COUNTRY_CODES } from "../../../constants/countries";

export const CLIENT_FORM_PERMISSIONS = {
    [COUNTRY_CODES.ECUADOR]: {
        canCreate: true,
        canRead: true,
        canUpdate: true,
        canDelete: false,
    },
    [COUNTRY_CODES.PARAGUAY]: {
        canCreate: true,
        canRead: true,
        canUpdate: true,
        canDelete: false,
    },
    [COUNTRY_CODES.HONDURAS]: {
        canCreate: false,
        canRead: true,
        canUpdate: false,
        canDelete: false,
    },
};

export const getClientFormPermissions = (country) => CLIENT_FORM_PERMISSIONS[country] || CLIENT_FORM_PERMISSIONS[COUNTRY_CODES.ECUADOR];
